export const getTextInHTMLTags = (content: string) => {
  const regex = /(<([^>]+)>)/ig
  const body = content
  const text = body.replace(regex, '')
  return text
}